// Mobilní lišta s produktem/kolekcí k článku.
// Ukáže se, až čtenář přescrolluje hlavičku článku (nebo první odstavec),
// a schová se, když je vidět newsletter, komentáře nebo patička.
if (!customElements.get('article-related-bar')) {
  customElements.define(
    'article-related-bar',
    class ArticleRelatedBar extends HTMLElement {
      connectedCallback() {
        this.storageKey = 'article-related-bar-closed';
        if (this.isClosed()) return;

        this.passedStart = false;
        this.blockers = new Set();

        const start =
          document.querySelector('.article-template__header') ||
          document.querySelector('.article-template__content-rte > *') ||
          document.querySelector('.article-template__content');
        if (!start || !('IntersectionObserver' in window)) return;

        this.startObserver = new IntersectionObserver(([entry]) => {
          this.passedStart = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.update();
        });
        this.startObserver.observe(start);

        const blockers = document.querySelectorAll(
          '.newsletter, .blog-aside__newsletter, .article-template__comment-wrapper, .shopify-section-group-footer-group, footer'
        );
        this.blockObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.blockers.add(entry.target);
            else this.blockers.delete(entry.target);
          });
          this.update();
        });
        blockers.forEach((el) => this.blockObserver.observe(el));

        this.querySelector('.article-related-bar__close')?.addEventListener('click', () => this.close());
      }

      disconnectedCallback() {
        this.startObserver?.disconnect();
        this.blockObserver?.disconnect();
      }

      update() {
        const visible = this.passedStart && this.blockers.size === 0;
        this.classList.toggle('is-visible', visible);
        this.toggleAttribute('inert', !visible);
        if (visible) document.documentElement.style.setProperty('--article-related-bar-height', `${this.offsetHeight}px`);
      }

      close() {
        try {
          sessionStorage.setItem(this.storageKey, this.dataset.key);
        } catch (e) {}
        this.disconnectedCallback();
        this.classList.remove('is-visible');
        this.setAttribute('inert', '');
      }

      isClosed() {
        try {
          return sessionStorage.getItem(this.storageKey) === this.dataset.key;
        } catch (e) {
          return false;
        }
      }
    }
  );
}
